// extracted by mini-css-extract-plugin
export default {"tickets":"ClaimTicketsPage_tickets__7n6nM","title":"ClaimTicketsPage_title__AVSqj"};